import * as actionTypes from './action-types';

export const getCountryYearGroupRequest = (countryCode, success, failure) =>
    ({ type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, countryCode, success, failure, countryCourses: [] });

export const getCountryYearGroupSuccess = yearGroups =>
    ({ type: actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS, isLoadingCountryCourses: false, yearGroups });

export const getCountryYearGroupFailure = () =>
    ({ type: actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE, isLoadingCountryCourses: false });

export const deselectCourses = (deselectCourse = true) =>
    ({ type: actionTypes.DESELECT_COURSE, deselectCourse });

export const getCourseCountry = selectedProductId =>
    ({ type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId });

export const getCourseCountrySuccess = data =>
    ({ type: actionTypes.GET_COUNTRY_SUCCESS, data });

export const getCourseCountryFailure = () =>
    ({ type: actionTypes.GET_COUNTRY_FAILURE });

export const getProductCourse = (countryCode, productId, yearGroup) =>
    ({ type: actionTypes.GET_PRODUCT_COURSE_REQUEST, countryCode, productId, yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true });

export const getProductCourseSuccess = data =>
    ({ type: actionTypes.GET_PRODUCT_COURSE_SUCCESS, data, isProductCoursesLoaded: true, isProductCoursesFetching: false });

export const getProductCourseFailure = () =>
    ({ type: actionTypes.GET_PRODUCT_COURSE_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

export const getSchoolCourse = yearGroup =>
    ({ type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup });



// WEBPACK FOOTER //
// ./app/containers/assign-courses-legacy/actions.js